module.exports = __webpack_public_path__ + "img/bianji-blue.cad052e2.svg";